import * as angular from 'angular';
import {
    applicationConfigurationModelFromDto,
    applicationConfigurationModelToDto
} from './application-configuration-form.functions';
import {
    loginServicesConfigurationModelFromDto,
    loginServicesConfigurationModelToDto
} from './login-services-form.functions';
import {
    registrationServicesConfigurationModelFromDto,
    registrationServicesConfigurationModelToDto
} from './registration-services-form.functions';

export class Controller {

    /** @ngInject */
    constructor($rootScope, $state, Alert, ApplicationsResource, PhotoUploadService) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.Alert = Alert;
        this.ApplicationsResource = ApplicationsResource;
        this.PhotoUploadService = PhotoUploadService;
    }

    $onInit() {
        this.resetApplicationConfiguration();
        this.resetLoginServicesConfiguration();
        this.resetRegistrationServicesConfiguration();
    }

    applicationConfigurationChanged($value, $invalid) {
        this.applicationConfiguration = $value;
        this.invalidApplicationConfiguration = $invalid;
    }

    applicationConfigurationIsNotModified() {
        return angular.equals(this.$applicationConfiguration, this.applicationConfiguration);
    }

    loginServicesConfigurationChanged($value, $invalid) {
        this.loginServicesConfiguration = $value;
        this.invalidLoginServicesConfiguration = $invalid;
    }

    loginServicesConfigurationIsNotModified() {
        return angular.equals(this.$loginServicesConfiguration, this.loginServicesConfiguration);
    }

    registrationServicesConfigurationChanged($value, $invalid) {
        this.registrationServicesConfiguration = $value;
        this.invalidRegistrationServicesConfiguration = $invalid;
    }

    registrationServicesConfigurationIsNotModified() {
        return angular.equals(this.$registrationServicesConfiguration, this.registrationServicesConfiguration);
    }

    resetApplicationConfiguration() {
        this.$applicationConfiguration = applicationConfigurationModelFromDto(this.application);
        this.applicationConfiguration = applicationConfigurationModelFromDto(this.application);
    }

    resetLoginServicesConfiguration() {
        this.$loginServicesConfiguration = loginServicesConfigurationModelFromDto(this.application);
        this.loginServicesConfiguration = loginServicesConfigurationModelFromDto(this.application);
    }

    resetRegistrationServicesConfiguration() {
        this.$registrationServicesConfiguration = registrationServicesConfigurationModelFromDto(this.application);
        this.registrationServicesConfiguration = registrationServicesConfigurationModelFromDto(this.application);
    }

    save(dto) {
        this.isSaving = true;
        return this.ApplicationsResource
            .updateApplicationConfiguration(this.companyId, this.application.id, dto)
            .then(() => {
                this.Alert('success', 'company.manage-application.configuration.saved');
                Object.assign(this.application, dto);
                this.$onInit();
                this.$state.reload('company.manage-application');
            })
            .finally(() => this.isSaving = false)
    }

    uploadFile() {
        this.ApplicationsResource.uploadCustomIcon(this.companyId,this.application.id,this.photoFile)
            .then((data)=> {
                // this.$state.reload(this.$state.current);
                this.$state.reload();
                this.Alert('success', 'saaspass_connect.updload_success');
        })
    }
    fileNameChanged(){
        if (this.photoFile.size > 1000000)
            this.Alert('danger', 'Photo should be smaller than 1MB');
    }

    saveApplicationConfiguration() {
        this.isSavingApplicationConfiguration = true;
        this.save({
            ...this.application,
            ...loginServicesConfigurationModelToDto(this.$loginServicesConfiguration),
            ...registrationServicesConfigurationModelToDto(this.$registrationServicesConfiguration),
            ...applicationConfigurationModelToDto(this.applicationConfiguration),
        }).finally(() => this.isSavingApplicationConfiguration = false)
    }

    changeApplicationStatus(saveAction) {
      if(saveAction){
        this.applicationConfiguration.isRunning = true;
        this.saveApplicationConfiguration();
      }else{
        const isRunning = this.application.status == 'RUNNING';
        const newStatus = !isRunning ? 'RUNNING' : 'PAUSED'
        return this.ApplicationsResource
            .changeApplicationStatus(
                this.companyId,
                this.application.id,
                newStatus
            )
            .then(() => {
                this.Alert('success', 'company.manage-application.configuration.saved');
                this.application.status = newStatus;
                this.$rootScope.$broadcast('breadcrumb-data-changed');
                this.$onInit();
            })
      }
    }

    saveLoginServicesConfiguration() {
    	debugger;
        this.isSavingLoginServicesConfiguration = true;
        this.save({
            ...this.application,
            ...applicationConfigurationModelToDto(this.$applicationConfiguration),
            ...registrationServicesConfigurationModelToDto(this.$registrationServicesConfiguration),
            ...loginServicesConfigurationModelToDto(this.loginServicesConfiguration),
        }).finally(() => this.isSavingLoginServicesConfiguration = false)
    }

    saveName(applicationName) {
        return this.ApplicationsResource
            .updateApplicationConfiguration(
                this.companyId,
                this.application.id,
                {
                    ...this.application,
                    ...applicationConfigurationModelToDto(this.$applicationConfiguration),
                    ...loginServicesConfigurationModelToDto(this.$loginServicesConfiguration),
                    ...registrationServicesConfigurationModelToDto(this.$registrationServicesConfiguration),
                    applicationName
                },
            )
            .then(() => {
                this.Alert('success', 'company.manage-application.configuration.saved-name');
                this.application.applicationName = applicationName;
                this.$rootScope.$broadcast('breadcrumb-data-changed');
                this.$onInit();
            })
    }

    saveRegistrationServicesConfiguration() {
        this.isSavingRegistrationServicesConfiguration = true;
        this.save({
            ...this.application,
            ...applicationConfigurationModelToDto(this.$applicationConfiguration),
            ...loginServicesConfigurationModelToDto(this.$loginServicesConfiguration),
            ...registrationServicesConfigurationModelToDto(this.registrationServicesConfiguration),
        }).finally(() => this.isSavingRegistrationServicesConfiguration = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/configuration/application-configuration.controller.js